const QCF_NAV_BACK = '__nav:back';

/** Map server suggestedActions to CockpitAssistChat quickActions + back flag. */
export function buildMenuActionsFromResponse(response, assistSession) {
  const suggested = response?.suggestedActions;
  if (Array.isArray(suggested) && suggested.length > 0) {
    const backAction = suggested.find(
      (a) => a.kind === 'nav' || a.message === QCF_NAV_BACK
    );
    const quickActions = suggested
      .filter((a) => a.kind !== 'nav' && a.message !== QCF_NAV_BACK)
      .map((a) => ({ label: a.label, message: a.message }));
    return {
      quickActions,
      showBack: Boolean(backAction),
      backMessage: backAction?.message || QCF_NAV_BACK,
    };
  }
  return buildMenuActionsFromSession(assistSession);
}

export function buildMenuActionsFromSession(assistSession) {
  const phase = assistSession?.phase;
  const menuLevel = assistSession?.menuLevel || 'root';

  if (
    phase === 'offer_accounting' ||
    phase === 'accounting_choose_source'
  ) {
    return {
      quickActions: [
        { label: 'Yes (upload)', message: 'Yes (upload)' },
        { label: 'Yes (Google Drive)', message: 'Yes (Google Drive)' },
        { label: 'No thanks', message: 'No thanks' },
      ],
      showBack: false,
      backMessage: QCF_NAV_BACK,
    };
  }
  if (phase === 'accounting_drive_same_or_new') {
    return {
      quickActions: [
        { label: 'Same folder', message: 'Same folder' },
        { label: 'New customer', message: 'New customer' },
      ],
      showBack: false,
      backMessage: QCF_NAV_BACK,
    };
  }
  if (phase === 'accounting_confirm_files' || phase === 'confirm_file') {
    return {
      quickActions: [
        { label: 'Confirm', message: 'yes' },
        { label: 'Pick alternate', message: 'no' },
      ],
      showBack: false,
      backMessage: QCF_NAV_BACK,
    };
  }

  if (menuLevel === 'source') {
    const track = assistSession?.menuTrack;
    if (track === 'marketing') {
      return {
        quickActions: [],
        showBack: true,
        backMessage: QCF_NAV_BACK,
      };
    }
    return {
      quickActions: [
        { label: 'Upload', message: '__menu:upload' },
        { label: 'Google Drive', message: '__menu:drive' },
      ],
      showBack: true,
      backMessage: QCF_NAV_BACK,
    };
  }

  if (menuLevel === 'active') {
    return {
      quickActions: [],
      showBack: true,
      backMessage: QCF_NAV_BACK,
    };
  }

  return {
    quickActions: [
      { label: 'Cohort', message: '__menu:cohort' },
      { label: 'Accounting', message: '__menu:accounting' },
      { label: 'Marketing', message: '__menu:marketing' },
    ],
    showBack: false,
    backMessage: QCF_NAV_BACK,
  };
}

export { QCF_NAV_BACK };
